import RcMenu from 'rc-menu'
import * as React from 'react'

import { NavItem } from '@joehua/buzz-cms-types'
import { renderItem } from './utils'
import navs from './navs.yml'

export interface MenuTheme {
  root?: string
  popupClassName?: string
  item?: string
  itemLink?: string
}

export interface MenuData {
  items: NavItem[]
  mode?: string
  openAnimation?: string
}

export interface MenuWithDataData {
  name: string
  mode?: string
  openAnimation?: string
  theme?: MenuTheme
}

export interface MenuWithDataProps {
  data: MenuWithDataData
  onLinkClick?: (item: NavItem) => void
  theme?: MenuTheme
}

function Menu({
  data: { mode, items, openAnimation },
  onLinkClick,
  theme,
}: {
  data: MenuData
  onLinkClick?: (item: NavItem) => void
  theme: MenuTheme
}) {
  return (
    <RcMenu mode={mode} className={theme.root} openAnimation={openAnimation}>
      {items.map((item, key) =>
        renderItem({ item, key: key.toString(), theme, onLinkClick }),
      )}
    </RcMenu>
  )
}

export default function MenuWithData({
  data: { name, mode, openAnimation },
  onLinkClick,
  theme = {},
}: MenuWithDataProps) {
  const items = navs[name]
  return (
    <Menu
      data={{
        mode,
        openAnimation,
        items,
      }}
      onLinkClick={onLinkClick}
      theme={theme}
    />
  )
}
